
import ScanImg from '@/assets/scan.png'
import CHeader from '@/components/Header'
import CPosition from '@/components/Position'
import {
formatDate
} from '@utils'
import {
scanQRCode
} from '@utils/wechat'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
name: 'Order',
components: {
Group,
Cell,
XInput,
XButton,
CHeader,
CPosition
},

data() {
return {
ScanImg: ScanImg,
ID:'',
}
},
created() {
this.TYPE = this.$route.query.TYPE || 0
this.$store.dispatch('baiduPosition')
let params = this.$route.query.params || '';
if (params) {
this.mapParams = JSON.parse(decodeURIComponent(params));
this.ID=this.mapParams.ID;
this.TYPE=this.mapParams.TYPE;
if(this.TYPE==0) this.loadThdData(this.ID)
else this.loadPsdData(this.ID)
}
},
computed: {
title() {
if (this.TYPE == 1) return '送货订单号'
else if (this.TYPE == 2) return '送货订单号'
else return '提货订单号'
},
placeholder() {
if (this.TYPE == 1) return '扫描送货码'
else if (this.TYPE == 2) return '扫描送货码'
else return '扫描提货码'
},
position() {
return this.$store.getters.getPosition
},
scan_type() {
if (this.TYPE == 2) return 1
return 0;
}
},
methods: {
openScan() {
if (this.TYPE == 2 && !this.position.addr) {
this.$toast.text('请等待拿到位置信息后再进行扫码上报位置')
return;
}
let _this = this;
scanQRCode(_this.scan_type).then(res => {
console.log('scan result', res)




_this.parseScanRes(res)
})
},
parseScanRes(res) {
let _this = this
let resArr = res.split(/\/thd\?|\/psd\?/)
if (resArr.length != 2) {
_this.$toast.text('扫码结果' + res + '无法解析到配送单信息')
return
}
var prj_code = resArr[0].split('/#/')[1] || 'bmw'
_this.$store.commit('setPrjCode', prj_code)
var params = {};
resArr[1].split('&').map(function(item) {
var s = item.split('=');
params[s[0]] = s[1];
});
if (res.indexOf('/thd?') != -1)
_this.loadThdData(params.ID, res)
else
_this.loadPsdData(params.ID, res)
},
loadThdData(ID, res) {
let _this = this
_this.$vux.loading.show()
let url = 'TH.ashx?action=Form_Load'
return this.$post(url, {
ID: ID,
}).then(
response => {
let TRANS_INFO = response.TRANS_INFO
if (!TRANS_INFO) {
_this.$toast.text('没有配送信息，无法巡更')
return;
}
if (TRANS_INFO.STATUS < 4 || TRANS_INFO.STATUS > 12) {
_this.$toast.warn('运输中的配送单才可巡更，当前状态【' + TRANS_INFO.STATUS_NAME + '】')
return;
}
_this.saveGpsLog(TRANS_INFO);
}
).catch(
response => {
this.$toast.warn('未获取到有效数据')
console.log(response, '请求失败')
}
)
},
loadPsdData(ID, res) {
let _this = this
_this.$vux.loading.show()
let url = 'Trans.ashx?action=Form_Load'
return this.$post(url, {
ID: ID,
}).then(
response => {
if (response.STATUS < 4 || response.STATUS > 12) {
_this.$toast.warn('运输中的配送单才可巡更，当前状态【' + response.STATUS_NAME + '】')
return;
}
_this.saveGpsLog(response);
}
).catch(
response => {
this.$toast.warn('未获取到有效数据')
console.log(response, '请求失败')
}
)
},
saveGpsLog(transInfo) {
let _this = this
_this.$vux.loading.show()
let url = 'Trans_GPS.ashx?action=Form_Save'
this.$post(url, {
TYPE: 1,
TRANS_ID: transInfo.ID,
GPS: transInfo.GPS,
CREATEDTIME: formatDate(),
GPS_TIME: formatDate(),
SLNG: _this.position.lng,
SLAT: _this.position.lat,
ADDR: _this.position.addr,
COMMAND: 'ADD'
}).then(
response => {
_this.$toast.text('车辆巡更完毕')
console.log(response)
}
).catch(
response => {
_this.$toast.warn('车辆巡更失败')
console.log(response, '请求失败')
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/Scan.vue